import type { FC } from "react";

import { useNotification } from "@react/foundation/notifications";

import { generationNotificationApi } from "@apis/generation/api";

import { useGenerationActions } from "../hooks/useGenerationActions.ts";

export const GenerationStatusListener: FC = () => {
  const { updateGeneration } = useGenerationActions();

  useNotification(
    "generation:generation:status-update",
    generationNotificationApi,
    generationPreview => {
      updateGeneration(generationPreview);
    },
  );

  return null;
};
